import React, {Component} from 'react';
import {connect} from "react-redux";
import {Button, Card, Col, Divider, message, PageHeader, Progress, Row} from 'antd';
import {watchPollStatus} from "../redux_actions/device_status.action";
import {sagaMiddleware} from "../helper/store";
import {openEndPoint} from "../utils/utils";
import {get} from "../helper/request";

export class VignetteDiagnostics extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isBusy: false, deviceId: this.props.match.params.id,
        }

        this.poller = null
    }

    componentDidMount = () => {
        this.poller = sagaMiddleware.run(watchPollStatus, this.props.dispatch, this.props.match.params.id);
    }

    componentWillUnmount() {
        this.poller.cancel()
    }

    vignetteCablibration = (objective) => {

        this.setState({
            isBusy: true,
        });
        const url = "/server/devices/" + this.state.deviceId + "/settings/vignette_diagnostics/" + objective;
        get(url)
        // .then(res => {
        //     message.success("Started Vigentte Calibration.");
        //     this.setState({
        //         isBusy: false,
        //     });
        // })
        // .catch(err => {
        //     message.error("Failed. Contact Admin");
        //     this.setState({
        //         isBusy: false,
        //     });
        // });
        message.success("Started Vigentte Calibration.");
    }

    goToSettings = (e) => {
        openEndPoint("/scanner_settings/" + this.state.deviceId, false, true);
    }

    render() {

        let scannerStatus = (((this.props.device || {}).scanner_health || {}).scanner_response || {});

        let isBusy = scannerStatus.busy;
        isBusy = isBusy === undefined ? false : isBusy;

        let percentDone = ((scannerStatus || {}).diagonosticsState || {}).vignetteRoutinePercentage || 0;
        if (percentDone >= 99) {
            percentDone = 100;
        }

        return (

            <div>
                <Row>
                    <Col offset={10} span={10}>
                        <PageHeader style={{backgroundColor: "#ffffff00", paddingBottom: "10px"}}
                                    title="Scanner Calibrations"></PageHeader>
                    </Col>
                    <Col span={4} style={{padding: '16px 24px'}}>
                        <Button type="primary" onClick={this.goToSettings} ghost>
                            Back to Settings
                        </Button>
                    </Col>
                </Row>
                <Divider/>
                <br></br>
                <Row>
                    <Col offset={6} span={12}>
                        <Card>
                            <Row>
                                <Col offset={0} span={6}>
                                    <Button type="primary" onClick={(e) => {
                                        e.stopPropagation();
                                        this.vignetteCablibration("FORTY_X")
                                    }} disabled={isBusy}>
                                        {percentDone === 100 ? "Restart Slide Calibration for 40X" : "Start Slide Calibration for 40X"}
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <Button type="primary" onClick={(e) => {
                                        e.stopPropagation();
                                        this.vignetteCablibration("TWENTY_X")
                                    }} disabled={isBusy}>
                                        {percentDone === 100 ? "Restart Slide Calibration for 20X" : "Start Slide Calibration for 20X"}
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <Button type="primary" onClick={(e) => {
                                        e.stopPropagation();
                                        this.vignetteCablibration("TEN_X")
                                    }} disabled={isBusy}>
                                        {percentDone === 100 ? "Restart Slide Calibration for 10X" : "Start Slide Calibration for 10X"}
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <Button type="primary" onClick={(e) => {
                                        e.stopPropagation();
                                        this.vignetteCablibration("FOUR_X")
                                    }} disabled={isBusy}>
                                        {percentDone === 100 ? "Restart Slide Calibration for 4X" : "Start Slide Calibration for 4X"}
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <Button type="primary" onClick={(e) => {
                                        e.stopPropagation();
                                        this.vignetteCablibration("HUNDRED_X")
                                    }} disabled={isBusy}>
                                        {percentDone === 100 ? "Restart Slide Calibration for 100X" : "Start Slide Calibration for 100X"}
                                    </Button>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <br></br>
                <Row>
                    <Col offset={6} span={12}>
                        <Card>
                            <Row>
                                <Col span={3}>
                                    <div style={{fontSize: '16px'}}>
                                        Progress
                                    </div>
                                </Col>
                                <Col span={19}>
                                    <Progress percent={percentDone.toFixed(2)} active/>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                {percentDone === 100 ? <><Divider/>
                    <Row>
                        <Col offset={10} span={6}>
                            <Button type="primary" onClick={this.goToSettings}>
                                All Done! Go back to Control Panel.
                            </Button>
                        </Col>
                    </Row></> : null}
            </div>)
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        device: state.deviceStatusReducer[ownProps.match.params.id]
    };
};

export default connect(mapStateToProps)(VignetteDiagnostics);
